

// Generated class AvailableRule_ManagedObject

class AvailableRule_ManagedObject extends MIOManagedObject
{
    
    
}
